import { Link } from "react-router-dom";
import { Instagram, Facebook, MessageCircle, BookOpen } from "lucide-react";
import { useStore } from "@/context/Store";
import { Container } from "./common";

export default function Footer() {
  const { settings, categories } = useStore();
  const wa = settings?.whatsapp || "351912861393";
  return (
    <footer className="mt-24 bg-[var(--ink)] text-white/80" data-testid="site-footer">
      <Container className="grid gap-12 py-16 md:grid-cols-5">
        <div className="md:col-span-2">
          <img src="/logo.jpg" alt="DUSA" className="h-24 w-24 rounded-3xl object-cover" />
          <p className="mt-3 max-w-sm text-sm leading-relaxed">Ideias que fazem marca. Vinis, murais, acrílicos, têxteis e comunicação visual feitos à tua medida.</p>
          <div className="mt-6 flex gap-3">
            {settings?.instagram && <a data-testid="footer-instagram-link" href={settings.instagram} target="_blank" rel="noreferrer" className="rounded-full bg-white/10 p-3 transition-colors hover:bg-[var(--pink)]" aria-label="Instagram"><Instagram className="h-4 w-4" /></a>}
            {settings?.facebook && <a data-testid="footer-facebook-link" href={settings.facebook} target="_blank" rel="noreferrer" className="rounded-full bg-white/10 p-3 transition-colors hover:bg-[var(--pink)]" aria-label="Facebook"><Facebook className="h-4 w-4" /></a>}
            <a data-testid="footer-whatsapp-link" href={`https://wa.me/${wa}`} target="_blank" rel="noreferrer" className="rounded-full bg-white/10 p-3 transition-colors hover:bg-[#1faa53]" aria-label="WhatsApp"><MessageCircle className="h-4 w-4" /></a>
          </div>
        </div>
        <div>
          <p className="eyebrow !text-[var(--pink)]">Loja</p>
          <ul className="mt-4 space-y-2 text-sm">{categories.map((c) => <li key={c.slug}><Link className="hover:text-white" to={`/c/${c.slug}`}>{c.title}</Link></li>)}</ul>
        </div>
        <div>
          <p className="eyebrow !text-[var(--pink)]">DUSA</p>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link className="hover:text-white" to="/sobre">Sobre a DUSA</Link></li>
            <li><Link className="hover:text-white" to="/perguntas">Perguntas frequentes</Link></li>
            <li><Link className="hover:text-white" to="/ideia">Ideia personalizada</Link></li>
            <li><Link data-testid="footer-track-link" className="hover:text-white" to="/acompanhar">Acompanhar pedido</Link></li>
            <li><a className="hover:text-white" href={`https://wa.me/${wa}`}>+{wa.replace(/^(\d{3})(\d{3})(\d{3})(\d{3})$/, "$1 $2 $3 $4")}</a></li>
          </ul>
        </div>
        <div>
          <p className="eyebrow !text-[var(--pink)]">Legal</p>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link data-testid="footer-terms-link" className="hover:text-white" to="/legal/termos">Termos e Condições</Link></li>
            <li><Link data-testid="footer-privacy-link" className="hover:text-white" to="/legal/privacidade">Política de Privacidade</Link></li>
            <li><Link data-testid="footer-returns-link" className="hover:text-white" to="/legal/devolucoes">Devoluções</Link></li>
          </ul>
          <a data-testid="footer-complaints-book-link" href="https://www.livroreclamacoes.pt/Inicio/" target="_blank" rel="noreferrer" className="mt-5 inline-flex items-center gap-2 rounded-xl bg-white px-3 py-2 text-xs font-bold text-[#c8102e] transition-transform hover:-translate-y-0.5"><BookOpen className="h-4 w-4" />Livro de Reclamações</a>
        </div>
      </Container>
      <div className="border-t border-white/10 px-5 py-6 text-center text-xs text-white/50" data-testid="footer-legal-info">© {new Date().getFullYear()} {settings?.legal_name || "DUSA"}{settings?.nif && ` · NIF ${settings.nif}`}{settings?.legal_address && ` · ${settings.legal_address}`} · Preços com IVA incluído</div>
    </footer>
  );
}

export function WhatsAppFab() {
  const { settings } = useStore();
  const wa = settings?.whatsapp || "351912861393";
  return (
    <a data-testid="whatsapp-fab" href={`https://wa.me/${wa}?text=${encodeURIComponent("Olá DUSA! Tenho uma dúvida.")}`} target="_blank" rel="noreferrer"
      className="fixed bottom-5 right-5 z-40 flex items-center gap-2 rounded-full bg-[#1faa53] px-4 py-3.5 text-sm font-semibold text-white shadow-2xl transition-transform hover:scale-105" aria-label="Falar por WhatsApp">
      <MessageCircle className="h-5 w-5" /><span className="hidden sm:inline">Fala connosco</span>
    </a>
  );
}
